// lib/kategorieText.js — Kategorie-Code mit Klartextnamen (18.10.2026)
//
// Überall standen nur Codes wie „JUBF-239“ oder „RUM46M“; außer dem, der sie
// angelegt hat, weiß niemand, was dahintersteckt. Eine Stelle für alle
// Seiten (Hallenschirm, Aufruf-Steuerung, Zeitplan, Check-in, Anmeldungen):
//   kategorieText('JUBF-239', 'Japanese, Hardstyle') → 'JUBF-239 · Japanese, Hardstyle'
//   kategorieText('JUBF-239', null)                  → 'JUBF-239'
//   kategorieText(null, 'Rumble 4-6 Jahre')          → 'Rumble 4-6 Jahre'
// Ist der Name gleich dem Code, steht er nur einmal da.
//
// CommonJS wie bruchtestVorschau.js, damit der Backend-Test
// (backend/utils/__tests__/kategorieText.test.js) dieselbe Datei prüft.

// Anzeige-Korrekturen an Namen aus der Datenbank (18.10.2026). NUR für die
// Anzeige: die DB-Werte („Continous Fighting“ ist auch Division_Type und
// wird an vielen Stellen verglichen) bleiben, wie sie sind.
function anzeigeName(name) {
  if (name == null) return '';
  return String(name).replace(/Continous/g, 'Continuous');
}

// Altersangabe aus divlisttdaalle.Age auf Deutsch: „18-29 years“ →
// „18–29 Jahre“, „11 & under“ → „bis 11 Jahre“, „45 & over“ → „ab 45 Jahren“.
// Unbekanntes bleibt stehen.
function altersText(age) {
  if (age == null) return '';
  const a = String(age).trim().replace(/\s+/g, ' ');
  if (!a) return '';
  if (/^mixed$/i.test(a)) return 'gemischt';
  let m = /^(\d+)\s*-\s*(\d+)\s*(years?)?$/i.exec(a);
  if (m) return `${m[1]}–${m[2]} Jahre`;
  m = /^-\s*(\d+)\s*(years?)?$/i.exec(a);
  if (m) return `bis ${m[1]} Jahre`;
  m = /^(\d+)\s*&\s*under$/i.exec(a);
  if (m) return `bis ${m[1]} Jahre`;
  m = /^(\d+)\s*&\s*over$/i.exec(a);
  if (m) return `ab ${m[1]} Jahren`;
  return a.replace(/\byears?\b/gi, 'Jahre');
}

function kategorieText(code, name) {
  const c = code == null ? '' : String(code).trim();
  const n = anzeigeName(name).trim();
  if (c && n && n.toLowerCase() !== c.toLowerCase()) return `${c} · ${n}`;
  return c || n || '—';
}

module.exports = { kategorieText, anzeigeName, altersText };
